import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMatOutward } from '../../../Store/PHPSlice/MatOutward';

const TableBody = ({
    id,
    serialNumber,
    dt,
    outwardNo,
    empNm,
    materialNm,
    description,
    sono,
    departNm,
    size,
    perpktqty,
    outpqty,
    pktqty,
    mtype,
    ptype,
    outmtr,
    outInch,
    outTotqty,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/MaterialOutwardEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Material Outward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleMatOutward(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Material Outward Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Material Outward:", error);
                    toast.error("Failed to delete Material Outward");
                });
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{dt}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{outwardNo}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{sono}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{departNm}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{empNm}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{materialNm}</TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{description}</TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {pktqty} {" "} {mtype}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {perpktqty}{" "} {ptype}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {outpqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {outmtr}
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {outInch}
                </TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {outTotqty}
                </TableCell>
                {/* <TableCell sx={{p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
